import { RoleDictionary, RoleItem } from "../../models/role.model";
import { BackendHttpService } from "../backendHttpService";

export class RoleDictionaryAdminService extends BackendHttpService {
  // Cache for roles dictionary
  private rolesDictionaryCache: RoleItem[] | null = null;
  private rawRolesDictionaryCache: RoleDictionary | null = null;

  constructor() {
    super("Project"); // Base endpoint is 'Project'
  }

  // Clear cache when needed
  private clearCache(): void {
    this.rolesDictionaryCache = null;
    this.rawRolesDictionaryCache = null;
  }

  // Get raw roles dictionary as string array
  async getRawRolesDictionary(): Promise<RoleDictionary> {
    if (this.rawRolesDictionaryCache) {
      return this.rawRolesDictionaryCache;
    }

    try {
      this.rawRolesDictionaryCache = await this.get<RoleDictionary>(
        "/rolesDictionary"
      );
      return this.rawRolesDictionaryCache;
    } catch (error) {
      console.error("Error getting raw roles dictionary:", error);
      throw error;
    }
  }

  // Get roles dictionary processed with generated IDs for UI display
  async getRolesDictionary(): Promise<RoleItem[]> {
    if (this.rolesDictionaryCache) {
      return this.rolesDictionaryCache;
    }

    try {
      const rolesArray = await this.getRawRolesDictionary();

      // Convert string array to array of objects with generated IDs
      this.rolesDictionaryCache = rolesArray.map((roleName, index) => ({
        id: index + 1, // Generate sequential IDs starting from 1
        name: roleName,
      }));

      return this.rolesDictionaryCache;
    } catch (error) {
      console.error("Error processing roles dictionary:", error);
      throw error;
    }
  }

  // Method to manually refresh the cache if needed
  async refreshRolesDictionary(): Promise<RoleItem[]> {
    this.clearCache();
    return this.getRolesDictionary();
  }
}

// Export singleton instance for convenience
export const roleDictionaryAdminService = new RoleDictionaryAdminService();
